import { render, staticRenderFns } from "./UIBtnIcon.vue?vue&type=template&id=1df393ed&scoped=true&"
import script from "./UIBtnIcon.vue?vue&type=script&lang=ts&"
export * from "./UIBtnIcon.vue?vue&type=script&lang=ts&"
import style0 from "./UIBtnIcon.vue?vue&type=style&index=0&id=1df393ed&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df393ed",
  null
  
)

export default component.exports